import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'app/fuse-template/core/auth/auth.service';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { FormService } from 'app/services/system/form/form.service';
import { DialogGeneral } from '../../DialogGeneral';

@Component({
    selector: 'dialog-audkenning-innskra',
    templateUrl: 'dialog-audkenning-innskra.html',
    styleUrls: ['dialog-audkenning-innskra.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogAudkennigInnskra extends DialogGeneral {
    constructor(
        public matDialogRef: MatDialogRef<DialogAudkennigInnskra>,
        private lsrauthService: LsrauthService,
        private authService: AuthService,
        private formService: FormService,
        private _router: Router,
        private dialog: MatDialog
    ) {
        super(matDialogRef);
        matDialogRef.disableClose = true;
    }

    lokaClick() {
        this.formService.clearAllDirtyForms();
        this.authService.signOut();
        this._router.navigate(['innskra']);
        try {
            this.dialog.closeAll();
            this.close();
        } catch {}
    }
}
